import * as React from 'react';
import { ICommand } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { OpenUrlAction } from '../../actions/openUrl/OpenUrlAction';
import CommandStrings from '../Commands.resx';
import { ShowOnlyWithSelection } from '../../selectionVisibility/SelectionVisibility';
import { isReadonlyFacet } from '../../../facets/CommandFacets';

export const openCommand: ICommand = {
  key: new Facet('open').id,
  automationId: 'openCommand',
  name: CommandStrings.Open,
  action: <ShowOnlyWithSelection><OpenUrlAction /></ShowOnlyWithSelection>,
  iconProps: {
    iconName: 'OpenFile'
  },
  facets: {
    ...isReadonlyFacet.pack(true)
  }
};
